import React from 'react';
import { CircularProgress } from '@mui/material';
import styles from './LoaderStyle.module.css';

const ComponentLoader = () => {
  return (
    <div className={`${styles['component-loader']}`}>
      <div className={`${styles['load-container']}`}>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{}}
        >
          <CircularProgress size={30} />
        </div>
      </div>
    </div>
  );
};

export default ComponentLoader;
